export default __webpack_public_path__ + "static/media/avatar_127.bd3be7d4.png";